export const LimitTariffsFromOperator = 15;
export const LimitOperatorsList = 8;
export const LimitPlansBTableContainer = 30